module.exports = __webpack_public_path__ + "img/portada13.7b48597c.png";